<template>
  <hot-header class="hot-application--animated-logo _text-break">
    <router-link exact :to="homeUrl" class="logo-link" slot="logo-link" @click="redirectToHome">Hotmart</router-link>
    <router-link
      slot="header-actions"
      :to="`/${currentProduct}/templates`"
      class="hot-button hot-button--primary _mx-4"
      v-if="shouldShowTemplates"
    >
      Templates
    </router-link>
    <header-tips
      class="header-action"
      v-if="isFromBrasil"
      @toggleTab="toggleTab"
    />
    <header-notifications
      class="header-action"
      @toggleTab="toggleTab"
    />
    <!-- <header-menu class="header-action"/> -->
    <header-avatar
      class="header-action"
      @toggleTab="toggleTab"
    />
  </hot-header>
</template>

<script>
  import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
  import api from 'store/modules/auth/api'
  import HeaderAvatar from './HeaderAvatar'
  import HeaderNotifications from './HeaderNotifications'
  import HeaderTips from './HeaderTips'

  export default {
    name: 'main-header',
    components: {
      HeaderAvatar,
      HeaderNotifications,
      HeaderTips
    },
    data () {
      return {
        hasTemplateRole: null,
        query: {},
        backAction: () => {
          this.setFeedback()
          this.$router.push({
            path: '/' + this.currentProduct,
            query: this.query
          })
        },
        isTipsActive: false,
        homeUrl: `/${this.getQueryStringUtmSource()}`
      }
    },
    computed: {
      ...mapState('auth', [
        'currentProduct'
      ]),
      ...mapState('dashboard', [
        'needFeedback',
        'hasFeedback'
      ]),
      ...mapGetters('auth', [
        'isFromBrasil'
      ]),
      isBuilder () {
        return this.$route.name && this.$route.name.indexOf('builder') !== -1
      },
      isPortugueseLang () {
        return this.$i18n && this.$i18n.locale === 'pt-BR'
      },
      shouldShowTemplates () {
        if (!this.currentProduct) {
          return false
        }
        return this.hasTemplateRole && !this.isBuilder
      }
    },
    methods: {
      ...mapMutations('dashboard', {
        setHasFeedback: 'SET_HAS_FEEDBACK'
      }),
      ...mapActions('gtag', {
        sendNavbarEvent: 'SEND_NAVBAR_EVENT'
      }),
      setFeedback () {
        if (this.needFeedback && !this.hasFeedback && this.isPortugueseLang) {
          this.query = {
            feedback: true
          }
          this.setHasFeedback(true)
        } else {
          this.query = {}
        }
      },
      updateBackAction (newBackAction) {
        this.backAction = newBackAction
      },
      redirectToHome () {
        this.$router.push({
          path: this.homeUrl
        })
      },
      getNewHomeUrl (route) {
        let path = '/'
        if (route.path.includes('builder')) {
          path = `/${this.currentProduct}`
        }
        return path
      },
      openHeaderTab (tabId) {
        const tab = document.getElementById(tabId)
        if (tab) {
          tab.click()
        }
      },
      toggleTab (tabId) {
        this.sendNavbarEvent({ item: tabId })
        const tab = document.getElementById(tabId)
        if (tab?.parentNode === document.activeElement) {
          tab.click()
        }
      },
      getQueryStringUtmSource () {
        const currentRoute = this.$router.currentRoute
        if (currentRoute?.query?.utm_source) {
          return `?utm_source=${currentRoute?.query?.utm_source}`
        }
        return ''
      }
    },
    watch: {
      isBuilder (check) {
        if (!check) {
          this.backAction = () => {
            this.setFeedback()
            this.$router.push({
              path: '/' + this.currentProduct,
              query: this.query
            })
          }
        }
      },
      $route (route) {
        this.hasTemplateRole = api.hasRole('checkout_builder_template')
        this.homeUrl = this.getNewHomeUrl(route)
      }
    },
    created () {
      this.$event.on('update-header-back', this.updateBackAction)
    },
    beforeDestroy () {
      this.$event.off('update-header-back', this.updateBackAction)
    }
  }
</script>

<style lang="scss">
  @import '~stylesheets/meta';

  .header-action {
    margin-left: 4px;
    margin-right: 4px;
  }

  .dropdown-button {
    cursor: pointer;
    transition: background 0.2s ease-in-out;

    &:hover {
      background: var(--gray-200)
    }
  }
</style>
